import { HomePage } from "../app/home";
import { IAppRoute, IAppRouteBase } from "../entities/app-route";
import { ObjectMap } from "../framework/entities/object-map";
import { forEach } from "../framework/utils/collection";
import { SignedOutPage } from "./pages/signed-out";

// use to build a regex that will match to a URL path without a bunch of escaping:
// e.g. /customers/:guid
// note that the URL starts with a slash.
// Placeholders are what make this useful. Use :guid to refer to a guid id (no dashes), and :int to refer to a whole number identifier
const buildRegex = (template: string) => {
    let normalizedTemplate = template.trim();
    normalizedTemplate = normalizedTemplate[0] === '/' ? normalizedTemplate.substring(1) : normalizedTemplate;

    const pathParts = normalizedTemplate.split('/');
    const actualParts = pathParts.map(p => {
        if(p === ':guid') {
            return '[0-9a-f]{32}';
        }
        if(p === ':int') {
            return '[0-9]+';
        }
        return p;
    });

    const rx = `^\\/${actualParts.join('\\/')}$`;
    return new RegExp(rx, 'i');
};
//avoid non-usage complaints
buildRegex('');

class AppRouteConfig {
    public home: IAppRoute = {
        key: 'home',
        urlTemplate: '/',
        url: () => '/',
        icon: 'Home',
        exact: true,
        regex: null,
        sideMenuLabel: 'Home',
        sideMenuSupported: false,
        topLevel: true,
        allowAnonymous: false,
        requiredRoles: [],
        component: HomePage,
    };

    public signedOut: IAppRoute = {
        key: 'signedOut',
        urlTemplate: '/signed-out',
        url: () => '/signed-out',
        icon: 'Home',
        exact: true,
        regex: null,
        sideMenuLabel: undefined,
        sideMenuSupported: false,
        topLevel: true,
        allowAnonymous: true,
        requiredRoles: [],
        component: SignedOutPage,
    };
    /*
    public claimsBroker_Edit: IAppRoute<(id: string) => string> = {
        key: 'brokerEdit',
        urlTemplate: '/broker/:id',
        url: (brokerId) => `/broker/${brokerId}`,
        icon: 'BusinessCenterLogo',
        exact: true
    };//*/
}

export const AppRoutes = new AppRouteConfig();

export function getAppRouteByKey(key: string): IAppRouteBase | undefined {
    const appRoutes = AppRoutes as unknown as ObjectMap<IAppRouteBase>;
    let selectedRoute: IAppRouteBase | undefined = undefined;

    forEach(appRoutes, route => {
        if(route.key === key) {
            selectedRoute = route;
            return false; // break
        }
    });

    return selectedRoute;
}

export const getAppRouteByPathname = (pathname: string): IAppRouteBase | undefined => {
    const appRoutes = AppRoutes as unknown as ObjectMap<IAppRouteBase>;
    let matchingRoute: IAppRouteBase | undefined = undefined;

    forEach(appRoutes, route => {
        if((!!route.regex && route.regex.test(pathname)) ||
        (!route.regex && route.urlTemplate === pathname.toLowerCase())) {
            matchingRoute = route;
            return false; // break;
        }
    });

    return matchingRoute;
}

export const getAppRoutesArray = (): IAppRouteBase[] => {
    const appRoutes = AppRoutes as unknown as ObjectMap<IAppRouteBase>;
    const routes: IAppRouteBase[] = [];

    forEach(appRoutes, route => {
        routes.push(route);
    });

    return routes;
};